import { render, staticRenderFns } from "./rulesContent.vue?vue&type=template&id=20e61b96&scoped=true"
import script from "./rulesContent.vue?vue&type=script&lang=js"
export * from "./rulesContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e61b96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e61b96')) {
      api.createRecord('20e61b96', component.options)
    } else {
      api.reload('20e61b96', component.options)
    }
    module.hot.accept("./rulesContent.vue?vue&type=template&id=20e61b96&scoped=true", function () {
      api.rerender('20e61b96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/tools/rateCalculator/copponents/rulesContent.vue"
export default component.exports